import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import { isIE, dependency } from '../utilities'
import mapStyle from './map/style'

const Map = Base.extend({
	directive: 'map',

	defaults: {
		apiKey: '',
		lat: 0,
		lng: 0,
		zoom: 0,
		marker: false,
		control: false,
		title: ''
	},

	modules: {

		markers: Base.extend({
			directive: 'marker',

			defaults: {
				lat: 0,
				lng: 0,
				title: false,
				url: false
			},

			methods: {

				setup()
				{
					const MapLabel = require('./map/label').default

					const markerSettings = this.$settings
					const markerPoint = new google.maps.LatLng(markerSettings.lat, markerSettings.lng)
					const infoContent = this.$element.innerHTML.trim()
					const mapMarker = new google.maps.Marker({
						map: this.$owner.map,
						position: markerPoint,
						title: markerSettings.title || ''
					})

					this.point = markerPoint
					this.marker = mapMarker

					if(markerSettings.url)
					{
						mapMarker.addListener('click', e => window.open(markerSettings.url, '_blank'))
					}
					else if(infoContent)
					{
						const markerInfo = new google.maps.InfoWindow({
							content: infoContent
						})

						this.info = markerInfo
						this.$owner.mapMarkerInfos.push(markerInfo)

						mapMarker.addListener('click', e =>
						{
							for(let info of this.$owner.mapMarkerInfos)
							{
								info.close()
							}

							markerInfo.open(this.$owner.map, mapMarker)
						})
					}

					if(this.$owner.$settings.marker && !isIE())
					{
						mapMarker.setIcon(this.$owner.$settings.marker)
					}

					if(this.$element.nodeName.toLowerCase() === 'a')
					{
						google.maps.event.addListener(mapMarker, 'click', function()
						{
							window.location.href = this.$element.getAttribute('href')
						})
					}

					const label = new MapLabel({map: this.$owner.map})
					label.bindTo('position', mapMarker, 'position')
					label.bindTo('text', mapMarker, 'title')
				}
			}
		}),

		searchers: Base.extend({
			directive: 'search',

			defaults: {
				zoom: 13
			},

			methods: {

				setup()
				{
					const map = this.$owner.map

					const $this = $(this.$element)

					const $input = $this.is('input') ? $this : $this.find('input[name="map-search"]')
					const input = $input[0]
					const searchText = $input.val()

					const $form = $(input.form)
					const form = $form[0]

					const searchBox = new google.maps.places.SearchBox(input)

					input.setAttribute('placeholder', '')

					// Bias the SearchBox results towards current map's viewport.
					map.addListener('bounds_changed', e => searchBox.setBounds(map.getBounds()))

					const findClosestMarkers = latLng =>
					{
						latLng = new google.maps.LatLng(latLng.lat, latLng.lng)

						const closestMarkers = this.$owner.$owns.markers.slice()
						closestMarkers.sort((a, b) =>
						{
							const aDist = google.maps.geometry.spherical.computeDistanceBetween(a.point, latLng)
							const bDist = google.maps.geometry.spherical.computeDistanceBetween(b.point, latLng)

							return aDist - bDist
						})

						return closestMarkers
					}

					const updateLocation = (places=null) =>
					{
						places = places || searchBox.getPlaces()

						if(places && places.length > 0)
						{
							const place = places[0]
							const closestMarkers = findClosestMarkers({
								lat: place.geometry.location.lat(),
								lng: place.geometry.location.lng()
							})
							const closestMarker = closestMarkers[0]

							map.panTo(closestMarker.point)
							map.setZoom(this.$settings.zoom)

							// Open info window
							if(closestMarker.info)
							{
								closestMarker.info.open(map, closestMarker.marker)
							}

							this.$owner.$settings.lat = closestMarker.point.lat
							this.$owner.$settings.lng = closestMarker.point.lng
							this.$owner.$settings.zoom = this.$settings.zoom
						}
					}

					$form.on('submit', e => { e.preventDefault(), updateLocation() })
					searchBox.addListener('places_changed', updateLocation)

					if(searchText)
					{
						google.maps.event.addListenerOnce(map, 'idle', () =>
						{
							const places = new google.maps.places.PlacesService(map)
							places.textSearch({ bounds: map.getBounds(), query: searchText }, updateLocation)
						})
					}
				}
			}
		})
	},

	events: {

		init: function()
		{
			const apiUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places&key=' + this.$settings.apiKey

			// Convert the zoom to an integer so Google doesn't complain
			this.$settings.zoom = this.$settings.zoom|0

			dependency(apiUrl, () =>
			{
				const point = new google.maps.LatLng(this.$settings.lat, this.$settings.lng)

				this.map = new google.maps.Map(this.$element, {
					center: point,
					zoom: this.$settings.zoom,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					scrollwheel: false,
					streetViewControl: false,
					draggable: this.$settings.control,
					panControl: false,
					overviewMapControl: false,
					zoomControl: this.$settings.control,
					mapTypeControl: false,
					disableDefaultUI: true,
					disableDoubleClickZoom: true,
					styles: mapStyle
				})

				this.mapMarkerInfos = []

				for(let marker of this.$owns.markers)
				{
					marker.setup()
				}

				for(let search of this.$owns.searchers)
				{
					search.setup()
				}

				$(window).on('resize', e =>
				{
					this.map.setCenter(point)
					this.map.setZoom(this.$settings.zoom)

					this.autoZoom()
				})

				google.maps.event.addListenerOnce(this.map, 'idle', () => this.autoZoom())
			},
			() => window.google && google.maps)
		}
	},

	methods: {

		autoZoom()
		{
			let containsAllMarkers = true

			const mapBounds = this.map.getBounds()
			const bounds = new google.maps.LatLngBounds()

			for(let marker of this.$owns.markers)
			{
				let markerPoint = new google.maps.LatLng(marker.$settings.lat, marker.$settings.lng)

				containsAllMarkers = containsAllMarkers && mapBounds.contains(markerPoint)
				bounds.extend(markerPoint)
			}

			if(!containsAllMarkers && this.$settings.zoom)
			{
				this.map.fitBounds(bounds)

				if(this.map.getZoom() > this.$settings.zoom)
				{
					this.map.setZoom(this.$settings.zoom)
				}
			}
		}
	}
})

export default Map



// WEBPACK FOOTER //
// ./source/scripts/modules/map.js